import type { To } from 'react-router';
import type { HostKind } from '#util/host.ts';

/**
 * The hosts-list location that most closely matches where a host of {@link kind} is listed:
 * lighthouses and relays land on the type-filtered list, plain hosts on the unfiltered one.
 * `baseSearch` (e.g. the persisted network filter) is preserved.
 */
export function hostsListTo(kind: HostKind, baseSearch = ''): To {
  const params = new URLSearchParams(baseSearch);
  if (kind !== 'host') params.set('filter.type', kind);
  const search = params.toString();
  return { pathname: '/hosts', search: search ? `?${search}` : undefined };
}
